import type {
  CombinedResultsFlightsInlineAdvert,
  CombinedResultsFlightsInlineAdvertById,
  CombinedResultsFlightsInlineState,
} from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/combinedResultsFlightsInline';

export const getAll = (
  state: CombinedResultsFlightsInlineState,
): CombinedResultsFlightsInlineAdvertById => state.byId;
export const get = (
  state: CombinedResultsFlightsInlineState,
  id: string,
): CombinedResultsFlightsInlineAdvert => state.byId[id];
